// Даты без времени в API — строки `YYYY-MM-DD` (contracts/api/common.ts, `isoDateSchema`).
// Ни отправлять, ни разбирать их через `Date#toISOString()` нельзя: тот переводит момент в UTC
// и в поясах восточнее Гринвича сдвигает календарный день на сутки назад — а заодно приделывает
// к дате время, которого схема не принимает вовсе (сервер отвечает 422).

/** `Date` → ISO `YYYY-MM-DD` по локальному календарю. */
export function toIsoDate(date: Date): string {
  const year = String(date.getFullYear()).padStart(4, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

/**
 * ISO `YYYY-MM-DD` → последний миг этого дня по локальным часам.
 *
 * Даты-границы в продукте включительные: отпуск «до 20 августа» действует весь день двадцатого
 * (сервер сравнивает `vacationUntil >= today`, см. contracts/domain/beacon.ts и джоб
 * `vacation_expire`). Разбор через `new Date('2026-08-20')` дал бы полночь **UTC**, и в
 * московском поясе отпуск, включённый по сегодняшнее число, выглядел бы уже закончившимся.
 */
export function endOfIsoDate(iso: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/u.exec(iso)
  if (!match) return null

  const [, year, month, day] = match

  return new Date(Number(year), Number(month) - 1, Number(day), 23, 59, 59, 999)
}
